import type { CustomCellEditorProps } from '@cmg/data-grid';
import { SelectFieldCellEditor } from '@cmg/data-grid';

import type { RolodexRecordStatus } from '../../../../../../graphql';
import { relationshipStatusOptions } from './RelationshipStatusCellEditor.model';

export function RelationshipStatusCellEditor<TData>({
  initialValue,
  eventKey,
  parseValue,
  onValueChange,
}: Readonly<CustomCellEditorProps<TData, RolodexRecordStatus>>) {
  return (
    <SelectFieldCellEditor
      eventKey={eventKey}
      options={relationshipStatusOptions}
      initialValue={initialValue}
      onValueChange={onValueChange}
      parseValue={parseValue}
    />
  );
}
